<div class="container-fluid p-0" id="renew-pwd">
    <div class="authentication-main">
        <div class="row">
            <div class="col-md-12">
                <div class="authentication-box">
                    <div class="text-center">
                    </div>
                    <div class="card mt-4">
                        <div class="card-body">
                            <div class="text-center">
                                <h4>Nouveau mot de passe</h4>
                            </div>
                            <div class="theme-form">
                                <!-- <div class="form-group">
                                    <label for="password" class="col-form-label">Mot de passe</label>
                                    <input class="form-control" type="password" id="password"required="" [(ngModel)]="pass">
                                </div>
                                <div class="form-group">
                                    <label for="passwordConfirmed" class="col-form-label">Confirmer le mot de passe</label>
                                    <input class="form-control" type="password" id="passwordConfirmed"required="" [(ngModel)]="passConfirmed" (keydown.enter)="resetPwd()">
                                </div> -->

                                <!-- <label style="color: #D80000" *ngIf="this.pass !== this.passConfirmed && this.passConfirmed"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Attention les mots de passe ne correspondent pas</label>
                                <label style="color: #4DCC5E;" *ngIf="this.pass === this.passConfirmed && this.pass">
                                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                                    Les mots de passe correspondent
                                </label> -->
                                <div>
                                    <form [formGroup]="form">
                                        <mat-form-field appearance="outline" style="width: 100%"
                                            [color]="passwordComponent.color">
                                            <mat-label>Mot de passe</mat-label>
                                            <mat-pass-toggle-visibility #toggleNewPwd matSuffix>
                                            </mat-pass-toggle-visibility>
                                            <input matInput #password [type]="toggleNewPwd.type" required
                                                placeholder="Mot de passe" formControlName="password"
                                                (focus)="inputPwdFocus = true" (blur)="inputPwdFocus = false">
                                            <mat-error *ngIf="form.controls['password'].invalid">Le mot de passe est
                                                obligatoire</mat-error>
                                            <mat-hint align="end" aria-live="polite">
                                                {{password.value.length}} / {{passwordComponent.max}}
                                            </mat-hint>
                                        </mat-form-field>

                                        <mat-password-strength #passwordComponent [password]="password.value">
                                        </mat-password-strength>

                                        <mat-password-strength-info *ngIf="inputPwdFocus"
                                            [lowerCaseCriteriaMsg]="'contient au moins une minuscule'"
                                            [upperCaseCriteriaMsg]="'contient au moins une majuscule'"
                                            [digitsCriteriaMsg]="'contient au moins un chiffre'"
                                            [specialCharsCriteriaMsg]="'contient au moins un caractère spécial'"
                                            [minCharsCriteriaMsg]="'contient au moins 8 caractères'"
                                            [passwordComponent]="passwordComponent">
                                        </mat-password-strength-info>

                                        <mat-form-field appearance="outline" style="width: 100%; margin-top: 1rem;">
                                            <mat-label>Confirmer le mot de passe</mat-label>
                                            <mat-pass-toggle-visibility #toggleNewPwdConfirmed matSuffix>
                                            </mat-pass-toggle-visibility>
                                            <input matInput [type]="toggleNewPwdConfirmed.type" required
                                                placeholder="Confirmer le mot de passe"
                                                formControlName="confirmedPassword">
                                            <mat-error
                                                *ngIf="form.controls['confirmedPassword'].pristine || form.controls['confirmedPassword'].errors?.MatchPassword">
                                                Les mots de passe ne correspondent pas</mat-error>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="form-group form-row mt-3 mb-0 login-button-block">
                                    <button class="btn btn-block login-button" type="submit"
                                        (click)="resetPwd()">Valider le mot de passe</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>